import { render } from "./ZutatenDuplikateView.vue?vue&type=template&id=7d60fd8b&scoped=true"
import script from "./ZutatenDuplikateView.vue?vue&type=script&lang=js"
export * from "./ZutatenDuplikateView.vue?vue&type=script&lang=js"

import "./ZutatenDuplikateView.vue?vue&type=style&index=0&id=7d60fd8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d60fd8b"]])

export default __exports__